import React from 'react';

import { ITableDataItem, IThConfig } from '../Table';
import { getWidthStyles } from '../helpers';
import Tooltip from 'src/components/UI/Tooltip/Tooltip';
interface IProps {
  tableDataItem: ITableDataItem;
  thConfig: IThConfig;
  thConfigIndex: number;
}
const TableDataElement = ({
  tableDataItem,
  thConfig,
  thConfigIndex,
}: IProps) => {
  const findedData = tableDataItem.elements[thConfig.columnId];
  let element = null;
  if (findedData?.element) {
    element = findedData.element;
  } else if (findedData?.text) {
    element = findedData.text;
  }
  const widthStyles = getWidthStyles(thConfig);

  return (
    <td
      key={thConfig.columnId}
      style={widthStyles}
      {...(findedData?.className ? { className: findedData.className } : {})}
    >
      {findedData.enableTooltip ? (
        <Tooltip
          message={element}
          className="table-tooltip"
          dropdownClassName="table-tooltip-message"
        >
          {element}
        </Tooltip>
      ) : (
        element
      )}
    </td>
  );
};

export default TableDataElement;
